import { HttpErrorResponse } from '@angular/common/http';
import { ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { Component, Input, NgZone, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs/internal/Subscription';
import { isNullOrUndefined } from 'util';
import { BulkApptGetRequest, TempList, TempListResponse } from '../../../models/appt.model';
import { ClassCodes, ClassCodesListResponse } from '../../../models/classCodes.model';
import { CLPUser, DDFields, DDFieldsResponse } from '../../../models/clpuser.model';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { Contact, ContactList, ContactListResponse, ContactResponse } from '../../../models/contact.model';
import { eSectionLead, eTempListStatus, eUserRole } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { SearchQuery, SearchQueryResponse } from '../../../models/search.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { AppointmentSettingService } from '../../../services/appointmentSetting.service';
import { ClassCodeService } from '../../../services/classCode.service';
import { ContactService } from '../../../services/contact.service';
import { GlobalService } from '../../../services/global.service';
import { NotificationService } from '../../../services/notification.service';
import { ReportService } from '../../../services/report.service';
import { ContactCommonSearchService } from '../../../services/shared/contact-common-search.service';
import { ContactSearchService } from '../../../services/shared/contact-search.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { formatNumber } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
declare var $: any;

@Component({
    selector: 'app-mailing-common',
    templateUrl: './mailing-common.component.html',
    styleUrls: ['./mailing-common.component.css'],
    providers: [GridConfigurationService, ContactCommonSearchService]
})
export class MailingCommonComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    emailMailingDataSource: MatTableDataSource<any>;
    emailMailingDataDisplayColumns: string[] = [];
    emailMailingData: ContactList[] = [];
    initEmailMailingData: ContactList[] = [];
    movedEmailMailingData: ContactList[] = [];
    queryDataLoaded: SearchQueryResponse
    MoveCount: number
    MoveCountFormatted: string
    @Output() searchQueryResponse: EventEmitter<SearchQueryResponse> = new EventEmitter<null>();
    contactListResponse: ContactListResponse;
    public mySelection: number[] = [];
    public refreshGrid: boolean = true;
    private encryptedUser: string = '';
    isInternational: boolean = false;
    showSpinner: boolean = false;
    @Input() roleFeaturePermissions: RoleFeaturePermissions;
    @Input() user: CLPUser;
    @Input() marketingType: string = 'email-blast';
    @Output() emailMailingList: EventEmitter<ContactList[]> = new EventEmitter<ContactList[]>();
    @Output() MoveCountParent: EventEmitter<number> = new EventEmitter<number>();
    @Input() contactOwner: boolean = false;
    @Output() isProcessAll: EventEmitter<boolean> = new EventEmitter<false>();
    @Output() csID: EventEmitter<number> = new EventEmitter<number>();
    @Output() isInternationalChecked: EventEmitter<boolean> = new EventEmitter<false>();
    @Output() bulkApptRequest: EventEmitter<BulkApptGetRequest> = new EventEmitter<BulkApptGetRequest>();
    @Input() showBackButton: boolean = false;
    @Output() onGoBack: EventEmitter<boolean> = new EventEmitter<false>();
    contactIds: number[] = [];
    gridHeight;
    soUrl: any;
    sendMailInfo: any = { isShow: false, contactId: 0 };
    mobileColumnNames: string[];
    paramSubscriptionUser: Subscription;
    /*@Input() csid: number = 0;*/
    @Input() csId: number = 0;
    //@Input()
    isCustomSearch: boolean = false;
    tempListId: number = 0;
    customSearchContact: Contact[];
    @ViewChild('selectAll', { static: false }) selectAll: ElementRef;
    dateFormat: string = "MM/dd/yyyy";
    columns = [
        { field: '$', title: ' ', width: '40' },
        { field: '$$', title: '  ', width: '40' },
        { field: 'name', title: 'Name', width: '187' },
        { field: 'email', title: 'Email', width: '83' },
        { field: 'companyName', title: 'Company', width: '363' },
        { field: 'phone', title: 'Phone', width: '113' },
        { field: 'userName', title: 'User', width: '113' },
        { field: 'city', title: 'City', width: '83' },
        { field: 'state', title: 'State', width: '83' },
        { field: 'zip', title: 'Zip', width: '83' },
        { field: 'dtModifiedDisplay', title: 'Modified', width: '113' },
        { field: 'action', title: '', width: '113' },
    ];
    reorderColumnName: string = 'name,email,companyName,phone,userName,city,state,zip,dtModifiedDisplay';
    columnWidth: string = 'name:187,email:83,companyName:363,phone:133,userName:133,city83,state83,zip83,dtModifiedDisplay:113';
    arrColumnWidth: any[] = ['name:187,email:83,companyName:363,phone:133,userName:133,city83,state83,zip83,dtModifiedDisplay:113'];


    /*-------------------------------------------------*/
    companyData: ClpCompany = <ClpCompany>{};
    selectedContactData: any;
    selectedCallType: string;
    isShowNewCallModal: boolean;
    currentUrl: string = "";
    tempEmailData: ContactList[] = [];
    selectAllBtn: boolean;
    @Output() ddInfoOrPromo: EventEmitter<number> = new EventEmitter<null>();
    savedSearch: SearchQuery[] = [];
    classCodes: ClassCodes[];
    totalContactCount: number = 0;
    strcontactSearchDisplay: string;
    totalContactCountFormatted: string;
    contactSearchDisplay = [];
    emailType: number = 2;
    private destroy$ = new Subject<void>();

    constructor(
        public _contactService: ContactService, private _accountSetupService: AccountSetupService,
        public _appointmentSettingService: AppointmentSettingService,
        private _utilityService: UtilityService,
        public _localService: LocalService,
        private _router: Router,
        private _globalService: GlobalService,
        private _contactCommonSearchService: ContactCommonSearchService,
        private _notifyService: NotificationService,
        public _gridCnfgService: GridConfigurationService,
        private _route: ActivatedRoute,
        private _classCodeService: ClassCodeService,
        private _reportService: ReportService,
        private _ngZone: NgZone) {
        this._localService.isMenu = true;
        this.gridHeight = this._localService.getGridHeight('493px');
        this.subscribeToEvents();
        _router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                var url = event.url;
                var splitUrl = url?.split('/', 4);
                this.currentUrl = splitUrl.length > 0 ? splitUrl[1].toString() : '';
                this.marketingType = this.currentUrl
            }
        });

        //Get route Parameters
        //this.paramSubscriptionUser = this._route.paramMap.subscribe(async params => {
        //    if (params.has('id')) {
        //        this.csId = +params.get('id');
        //        this.isCustomSearch = true;
        //    }
        //});
        this.paramSubscriptionUser = this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(async params => {
            if (params?.csId) {
                this.csId = +params['csId'];
                this.isCustomSearch = true;
            }
        });
    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    this.dateFormat = this.user.dateFormat;
                    this.getClassCodes();
                    if (this.currentUrl == "direct-mail")
                        this.marketingType = "direct-mail";
                    this.getCompany();
                }
                else
                    this._router.navigate(['/login']);
            }
            else
                this._router.navigate(['/login']);
        })
    }


    setUp() {
    }

    async getCompany() {
        this.companyData = JSON.parse(localStorage.getItem('company'));
        if (this.companyData == undefined || this.companyData == null || Object?.keys(this.companyData)?.length == 0) {
            await this.getCompanyData();
        }
        if (!this.companyData?.secMarketingTool) {
            if (this.user?.userRole == eUserRole.General)
                this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
        }
        //Kendo grid load call stopped.
        //this.getGridConfiguration();
        this.getArchiveContacts();
        if (this.csId > 0) {
            this.isCustomSearch = true;
        }
        if (this.isCustomSearch) {
            this.getContactsCsId();
        }
    }

    async getCompanyData() {
        this.companyData = await this._localService.loadCompany();
        if (this.companyData == null) {
            await this._accountSetupService.getClpCompany(this.encryptedUser, this.user.cLPCompanyID)
                .then(async (result: CompanyResponse) => {
                    if (!isNullOrUndefined(result)) {
                        var response = UtilityService.clone(result);
                        this.companyData = response.company;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("mailing-common.getCompanyData", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID + 'slurpyUserId ' + this.user?.slurpyUserId);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private subscribeToEvents(): void {
        this._contactCommonSearchService.contactListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {

                this.selectAllBtn = false;
                this.movedEmailMailingData = [];

                this.emailMailingData = data;

                this.initEmailMailingData = this.emailMailingData.map(x => Object.assign({}, x));
                this.setGrid(this.emailMailingData);

            })
        });
        this._contactCommonSearchService.queryListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.queryDataLoaded = data;
                this.searchQueryResponse.emit(this.queryDataLoaded);

            })
        });
        //this._contactCommonSearchService.contactCountChanged.subscribe((data) => {
        //    this._ngZone.run(() => {
        //        this.SearchCount = data;              

        //    })
        //});
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.user = this.user;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'email_mailing_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('email_mailing_grid').subscribe((value) => { }));

    //}
    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'email_mailing_grid').subscribe((value) => this.getGridConfiguration());
    //}

    getArchiveContacts() {
        if (!isNullOrUndefined(this._gridCnfgService)) {
            this._gridCnfgService.iterateConfigGrid(true, "email_mailing_grid");
            this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('email_mailing_grid');
        }
    }

    gotoLink(columnName, dataItem) {
        if (columnName) {
            switch (columnName) {
                case "name": {
                    if (this.user.timeZoneWinId != 0) {
                        let url = '/contact/' + dataItem.contactID;
                        return url;
                    }
                    else {
                        if (confirm("First , Please select your timezone!!!"))
                            this._router.navigate(['/edit-profile', dataItem.clpUserId]);
                        else
                            return;
                    }
                    break;
                }
                case "userName": {
                    return `/edit-profile/${dataItem.clpUserId}`;
                }
                case "email": {
                    $('#mailingSendEmailModal').modal('show');
                    this.sendMailInfo.isShow = true;
                    this.sendMailInfo.contactId = dataItem?.contactID;
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }

    hideSendMail() {
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
        $('#mailingSendEmailModal').modal('hide');
    }

    moveRight() {
        if (!this.mySelection || this.mySelection.length === 0) {
            this._notifyService.showError("Select at least one record", "Error", 3000);
            return;
        }

        this.showSpinner = true;
        this.refreshGrid = false;


        const sourceData =
            !this.emailMailingData || this.emailMailingData.length === 0
                ? [...this.initEmailMailingData]
                : [...this.emailMailingData];

        const selectedIds = new Set(this.mySelection);

        // Move selected items
        const movedItems = sourceData.filter(item =>
            selectedIds.has(item.contactID)
        );

        this.movedEmailMailingData.push(...movedItems);
        this.contactIds.push(...this.mySelection);

        // Remove moved items from source
        this.emailMailingData = sourceData.filter(
            item => !selectedIds.has(item.contactID)
        );

        // Refresh grid AFTER update
        this.setGrid(this.emailMailingData);

        //this.setTotalContactCount(this.emailMailingData?.length);

        // Count logic
        this.MoveCount = this.selectAllBtn
            ? this.totalContactCount
            : this.movedEmailMailingData.length;

        this.MoveCountParent.emit(this.MoveCount);
        this.MoveCountFormatted = formatNumber(
            Number(this.MoveCount),
            'en-US',
            '1.0-0'
        );



        if (this.marketingType === 'Bulk-Appointment') {
            this.apptMoveRight();
        }

        this.addTimeout(() => {
            this.refreshGrid = true;
            this.showSpinner = false;
        }, 1);

        this.mySelection = [];
    }


    async apptMoveRight() {
        await this._appointmentSettingService.bulkApptMoveRight(this.encryptedUser, this.user.cLPCompanyID, this.user.cLPUserID, eTempListStatus.Pending, this.mySelection)
            .then(async (result: TempListResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.tempListId = response?.tempList.tempListID;
                    this._notifyService.showSuccess('Contacts have been moved successfully.', '', 3000);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("mailing-common.apptMoveRight", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID + 'TempListStatus ' + eTempListStatus.Pending + 'mySelection ' + this.mySelection);
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyBulkApptValues() {
        var bulkAppt = <BulkApptGetRequest>{};
        bulkAppt.tempListID = this.tempListId;
        bulkAppt.contactIds = this.contactIds;
        bulkAppt.isRestoreAll = false;
        bulkAppt.savedQueryID = 0;
        bulkAppt.searchQuery = this.queryDataLoaded;
        this.bulkApptRequest.emit(bulkAppt);
    }

    clearMovedList() {
        this.movedEmailMailingData = [];
        this.contactIds = [];
        this.emailMailingData = this.initEmailMailingData;
        this.setGrid(this.emailMailingData);
    }

    goToNext() {
        //if (this.movedEmailMailingData?.length == this.initEmailMailingData?.length)
        //    this.isProcessAll.emit(true);
        //else
        //    this.isProcessAll.emit(false);
        if (this.marketingType == 'Bulk-Appointment')
            this.copyBulkApptValues();
        else {
            this.emailMailingList.emit(this.movedEmailMailingData);
        }
    }

    public selectAllState: SelectAllCheckboxState = "unchecked";
    public onSelectAllChange(checkedState: SelectAllCheckboxState): void {

        this.selectAllBtn = true;
        this.mySelection = [];
        if (checkedState === "checked") {
            this.mySelection = this.emailMailingData.map((item) => item.contactID);
            this.selectAllState = "checked";
        } else {
            this.mySelection = [];
            this.selectAllState = "unchecked";
        }

        if (this.selectAllBtn) {
            this.isProcessAll.emit(true)
            this.csID.emit(this.isCustomSearch ? this.csId : 0)
            //this.moveRight();
        }
        else {
            this.isProcessAll.emit(false)
        }

        //this.selectAllBtn = false

        this.moveRight();
        //this.selectAllBtn = false
    }

    //public onSelectedKeysChange(): void {
    //  const len = this.mySelection.length;

    //  if (len === 0) {
    //    this.selectAllState = "unchecked";
    //  } else if (len > 0 && len < this.emailMailingData?.length) {
    //    this.selectAllState = "indeterminate";
    //  } else {
    //    this.selectAllState = "checked";
    //  }
    //}


    async getContactsCsId() {
        await this._reportService.getContactsByCustomSearchId(this.encryptedUser, this.user?.cLPCompanyID, this.csId, this.user?.cLPUserID, this.marketingType == "email-blast" ? 2 : this.marketingType == "direct-mail" ? 1 : 3)
            .then(async (result: ContactResponse) => {
                if (!isNullOrUndefined(result)) {
                    var response = UtilityService.clone(result);
                    this.customSearchContact = response.contactList;
                    this.emailMailingData = [];
                    this.customSearchContact?.forEach(x => {
                        var emailMailData: ContactList = <ContactList>{};
                        emailMailData.contactID = x.contactID;
                        emailMailData.name = x.firstName + ' ' + x.lastName;
                        emailMailData.firstName = x.firstName;
                        emailMailData.lastName = x.lastName;
                        emailMailData.email = x.email;
                        emailMailData.companyName = x.companyName;
                        emailMailData.phone = x.phone;
                        emailMailData.mobile = x.mobile;
                        emailMailData.homePhone = x.homePhone;
                        emailMailData.add1 = x.add1;
                        emailMailData.add2 = x.add2;
                        emailMailData.add3 = x.add3;
                        emailMailData.city = x.city;
                        emailMailData.state = x.state;
                        emailMailData.zip = x.zip;
                        emailMailData.country = x.country;
                        emailMailData.dtModified = new Date(x.dtModified);
                        emailMailData.dtCreated = new Date(x.dtCreated);
                        emailMailData.dtModifiedDisplay = new Date(x.dtModified);
                        emailMailData.dtCreatedDisplay = new Date(x.dtCreated);
                        emailMailData.userName = x.uFirstName + ' ' + x.uLastName;
                        emailMailData.uFirstName = x.uFirstName;
                        emailMailData.uLastName = x.uLastName;
                        emailMailData.clpUserId = x.cLPUserID;
                        emailMailData.class1Code = x.class1Code;
                        this.emailMailingData.push(emailMailData);
                    });
                    this.initEmailMailingData = this.emailMailingData;
                    this.setGrid(this.emailMailingData);
                    this.setTotalContactCount(response.messageInt);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mailing-common.getContactsCsId", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID + 'csId ' + this.csId + 'cLPUserID ' + this.user?.cLPUserID + 'marketingType ' + this.marketingType);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    selectAllContacts() {
        //this.selectAllBtn = false; 
        //this.mySelection = this.emailMailingData.map(x => x.contactID);
        //this.moveRight();        
        this.onSelectAllChange("checked");
        if (this.mySelection && this.emailMailingDataSource && this.emailMailingDataSource.data.length > 0) {
            return this.mySelection.length == this.emailMailingDataSource.data.length;
        }
    }

    changeIsInternation(value: boolean) {
        this.isInternationalChecked.emit(value);
    }

    openModalNewCall(contactData, callType: string) {
        this.selectedContactData = contactData;
        this.selectedCallType = callType;
        this.isShowNewCallModal = true;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
        this.paramSubscriptionUser?.unsubscribe();
    }

    changeDdInfoOrPromo(event) {
        if (event && event?.target?.value) {
            this.emailType = event?.target?.value;
            this.ddInfoOrPromo.emit(event.target.value);
        }
    }

    setSavedSearch(event: SearchQuery[]) {
        this.savedSearch = event;
    }

    async getClassCodes() {
        this.showSpinner = true;
        await this._classCodeService.getClassCodes(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: ClassCodesListResponse) => {
                if (result) {
                    this.classCodes = UtilityService.clone(result.classCodes);
                    //for (var i = 0; i < this.classCodes.length; i++) {
                    //    this.classCodes[i].key = this.classCodes[i].tableName + " : " + this.classCodes[i].classCodeTitle;
                    //}
                    //this.groupByClassCode = this.groupBy(this.classCodes, x => x.key);
                    //this.getUploadExcelConfig();
                    this.showSpinner = false;
                }
                else {
                    this.showSpinner = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    getClassCodeTitle(searchItem) {
        if (this.classCodes?.length > 0) {
            return this.classCodes?.filter((item) => item?.tableName == searchItem)[0]?.classCodeTitle;
        }
    }

    setTotalContactCount(event: number) {
        this.totalContactCount = event;
        this.totalContactCountFormatted = formatNumber(Number(this.totalContactCount), 'en-US', '1.0-0');
    }


    setContactSearchDisplay(event) {
        this.strcontactSearchDisplay = event;
    }

    setGrid(list) {
        if (this.marketingType != 'direct-mail') {
            this.columns = this.columns.filter(col =>
                !['city', 'state', 'zip'].includes(col.field)
            );
        }
        if (this.marketingType == 'direct-mail') {
            this.columns = this.columns.filter(col =>
                !['email', 'phone'].includes(col.field)
            );
        }
        this.emailMailingDataDisplayColumns = this.columns.map(c => c.field);
        this.emailMailingDataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.emailMailingDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('email_mailing_grid') ? this._localService.getPageSize('email_mailing_grid') : 50;
            }
            if (this.sort) {
                this.emailMailingDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('email_mailing_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)

    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    toggleSelection(row) {
        const index = this.mySelection.findIndex(r => r == row.contactID);
        if (index >= 0) {
            this.mySelection.splice(index, 1);
        } else {
            this.mySelection.push(row.contactID);
        }
    }

    isSelected(row): boolean {
        return this.mySelection.includes(row.contactID);
    }

    toggleSelectAll(event: any) {
        const pageData = this.getCurrentPageData();
        if (event.checked) {
            pageData.forEach(row => {
                if (!this.mySelection.includes(row.contactID)) {
                    this.mySelection.push(row.contactID);
                }
            });
        } else {
            this.mySelection = this.mySelection.filter(id => !pageData.some(row => row.contactID === id));
        }

        //this.selectAllBtn = true;
        //this.mySelection = [];
        //if (event.checked) {
        //    this.mySelection = this.emailMailingDataSource.data.map((item) => item.contactID);
        //    this.selectAllState = "checked";
        //} else {
        //    this.mySelection = [];
        //    this.selectAllState = "unchecked";
        //}

        //if (this.selectAllBtn) {
        //    this.isProcessAll.emit(true)
        //    this.csID.emit(this.isCustomSearch ? this.csId : 0)
        //    //this.moveRight();
        //}
        //else {
        //    this.isProcessAll.emit(false)
        //}

        ////this.selectAllBtn = false

        //this.moveRight();
        ////this.selectAllBtn = false
    }

    isAllSelected(): boolean {
        if (this.mySelection && this.emailMailingDataSource && this.emailMailingDataSource.data.length > 0) {
            return this.mySelection.length == this.emailMailingDataSource.data.length;
        }
        return false;
    }

    isIndeterminate(): boolean {
        const pageData = this.getCurrentPageData();
        const selectedCount = pageData.filter(row => this.mySelection.includes(row.contactID)).length;
        return selectedCount > 0 && selectedCount < pageData.length;
    }


    //isIndeterminate(): boolean {
    //    return this.mySelection.length > 0 && !this.isAllSelected();
    //}

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    getCurrentPageData(): any[] {
        if (!this.paginator || !this.emailMailingDataSource) {
            return [];
        }
        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        return this.emailMailingDataSource.filteredData.slice(startIndex, startIndex + this.paginator.pageSize);
    }
}
